import baseUrl from "./Configs";

const VISITOR_KEY = "spellstudyVisitorId";
const SESSION_KEY = "spellstudySessionId";

const createId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getAnalyticsIdentity = () => {
  let visitorId = localStorage.getItem(VISITOR_KEY);
  if (!visitorId) {
    visitorId = createId();
    localStorage.setItem(VISITOR_KEY, visitorId);
  }

  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = createId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return { visitorId, sessionId };
};

export const trackAnalyticsEvent = (payload) => {
  try {
    const body = JSON.stringify({
      ...payload,
      ...getAnalyticsIdentity(),
      page: payload.page || window.location.pathname,
    });
    const url = `${baseUrl}/v1/analytics/track`;
    const token = localStorage.getItem("token");

    if (!token && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(url, blob)) return;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Analytics should never affect user-facing flows.
  }
};
